import { render, staticRenderFns } from "./FormNewUser.vue?vue&type=template&id=1c31d09c&scoped=true&"
import script from "./FormNewUser.vue?vue&type=script&lang=js&"
export * from "./FormNewUser.vue?vue&type=script&lang=js&"
import style0 from "./FormNewUser.vue?vue&type=style&index=0&id=1c31d09c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31d09c",
  null
  
)

export default component.exports